import { CSSProperties } from 'react';

interface Props {
  name: string;
  type?: 'outlined' | 'filled';
  yAdjust?: number;
  style?: CSSProperties;
  className?: string;
}

function MaterialIcon(props: Props) {
  let className = (props.className ?? "") + ' material-icons';
  if (props.type && props.type !== 'filled')
    className += `-${props.type}`;

  let style = { ...props.style };
  if (props.yAdjust)
    style = { position: "relative", top: `${props.yAdjust}px`, ...style }

  return (
    <span className={className} style={style}>
      {props.name}
    </span>
  );
}

export default MaterialIcon;
